import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

import {
  Component,
  ElementRef,
  ViewChild,
  OnInit,
  AfterViewInit,
  OnDestroy
} from "@angular/core";

import { Dialog, DialogRef, DialogParams } from "../../dialog.base";

@Component({
  selector: "uex-dialog-viewer",
  templateUrl: "viewer.component.html",
  host: {
    class: "uex-dialog-viewer"
  }
})
export class DialogViewerComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("image", { static: false }) private _imageElement: ElementRef<
    HTMLImageElement
  >;

  constructor(
    private _dialogRef: DialogRef,
    private _dialogParams: DialogParams,
    private _domSanitizer: DomSanitizer
  ) {
    this._dialog = this._dialogRef.dialog;
    this.src = this._dialogParams.get("src");
    this.type = this._dialogParams.get("type");
    this._prepareVideo();
  }

  private _dialog: Dialog;

  public src: string | SafeResourceUrl;
  public type: "image" | "video" = "image";
  public video_type?: "youtube" | "vimeo";
  public loading: boolean = false;
  public error: boolean = false;

  private _listeners = {
    load: () => this._onLoad(),
    error: () => this._onError()
  };

  public ngOnInit() {
    if (this.type === "image") {
      this.loading = true;
    }
  }

  public ngAfterViewInit() {
    if (this.type === "image") {
      this._imageElement.nativeElement.addEventListener(
        "load",
        this._listeners.load
      );
      this._imageElement.nativeElement.addEventListener(
        "error",
        this._listeners.error
      );
    }
  }

  public ngOnDestroy() {
    if (this.type === "image") {
      this._imageElement.nativeElement.removeEventListener(
        "load",
        this._listeners.load
      );
      this._imageElement.nativeElement.removeEventListener(
        "error",
        this._listeners.error
      );
    }
  }

  private _onLoad() {
    this.loading = false;
  }

  private _onError() {
    this.loading = false;
    this.error = true;
  }

  private _prepareVideo() {
    if (this.type !== "video") return;

    const src = this.src as string;
    let match: RegExpMatchArray;

    this.video_type = src.indexOf("vimeo") > -1 ? "vimeo" : "youtube";

    switch (this.video_type) {
      case "vimeo":
        match = src.match(/vimeo.com\/(video\/)?([\d]+)$/);
        this.src =
          match && match.length
            ? this._sanitizeUrl(
                `https://player.vimeo.com/video/${match[2]}?title=0&byline=0&portrait=0`
              )
            : this.src;
        break;

      case "youtube":
        match = src.match(
          /youtu\.?be(\.com)?\/(embed\/|watch\?v=)?([A-z0-9]+)$/
        );
        this.src =
          match && match.length
            ? this._sanitizeUrl(`https://www.youtube.com/embed/${match[3]}`)
            : this.src;
        break;
    }

    this._dialog.setSettings({
      dialog_class: `${this._dialog.settings.dialog_class} uex-dialog-viewer-dialog-embed`
    });

    if (document.getElementById("vimeo-player-script")) return;

    const script = document.createElement("script");
    script.id = "vimeo-player-script";
    script.src = "https://player.vimeo.com/api/player.js";
    document.body.appendChild(script);
  }

  private _sanitizeUrl(url: string): SafeResourceUrl {
    return this._domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
